// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Slice from "../slice"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { showSnackBar } from "../../snackbar/actions"
import { timesheetFieldClient } from "../../../app/rpc/client"
import {
  ListTimesheetFieldOptionsRequest,
  ListTimesheetFieldOptionsResponse,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type ListTimesheetFieldOptionsRpc = (request: ListTimesheetFieldOptionsRequest) => Observable<ListTimesheetFieldOptionsResponse>

export const listTimesheetFieldOptions = (listTimesheetFieldOptionsRpc: ListTimesheetFieldOptionsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.listTimesheetFieldOptions.match),
      mergeMap(action => of(action.payload)
        .pipe(
          mergeMap(listTimesheetFieldOptionsRpc),
          map(response => ({
            timesheetFieldId: action.payload.getTimesheetFieldId(),
            response: response.toObject(),
          })),
          map(Slice.setTimesheetFieldOptions),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_list_timesheet_field_options_failed",
              message: "Failed to load timesheet field options. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const listTimesheetFieldOptionsRpc = (request: ListTimesheetFieldOptionsRequest): Observable<ListTimesheetFieldOptionsResponse> =>
  grpc(() => timesheetFieldClient.listTimesheetFieldOptions(request, null))

export default listTimesheetFieldOptions(listTimesheetFieldOptionsRpc)
